import TeachingPeriodsReducer from './TeachingPeriodsReducer';
export default TeachingPeriodsReducer;
